import { pad } from '../pad';

export const getDateTime = (date: string) => {
  const dateObject = date.includes('Z') ? new Date(date) : new Date(date + 'Z');

  return pad(dateObject.getHours()) + ':' + pad(dateObject.getMinutes());
};
